import {combineReducers} from 'redux'
import {types} from '../actions'

export let initialState = {
    pageOne: {
        loading: false,
        user: 'Bougie'
    }
}

let reducers = combineReducers({
    pageOne(state = {}, action) {
        const mutations = {
            [types.LOGIN_LOADING]: {
                ...state, loading: action.payload
            },
            [types.SET_USER]: {
                ...state, user: action.payload
            }
        }
        return mutations[action.type] ? mutations[action.type] : state
    }
})

export default reducers


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js